import {Stack} from '@mui/material';
import React from 'react';
import {ResursLoading} from '@resurs-internal/mui';

export const BankIDViewLoading = () => {
  return (
    <Stack
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <ResursLoading />
    </Stack>
  );
};
